module.exports = __webpack_public_path__ + "static/media/rogue3_preview.b4a7ca66.jpg";